

export class VehicleTypeUpdateInput implements IVehicleTypeUpdateInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId!: number;
    /** The vehicle type  name with 255 character limit */
    vehicleTypeName!: string;

    constructor(data?: IVehicleTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
        }
    }

    static fromJS(data: any): VehicleTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        return data; 
    }
}

export interface IVehicleTypeUpdateInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId: number;
    /** The vehicle type  name with 255 character limit */
    vehicleTypeName: string;
}

